module.exports = __webpack_public_path__ + "d9949341cb94c7e68380133587722557.svg";